import { EventSourceStream } from './code/ess';
import { consoleReporter } from './reporters/console';

const ess = new EventSourceStream();

ess.reporters = {
  console: consoleReporter
};

export default ess;
